import { getNextPage, pageParams, retrieveFromStorage, saveToStorage } from "../../Components/Functions";
import Api from "../../Server/Api";
import { USER_AUTHENTICATION_DATA } from "../User/types";
import { UPDATE } from "./types";

const api = new Api();

const { user } = retrieveFromStorage(USER_AUTHENTICATION_DATA)||{};


export const updateRecords = (data = {}) => {
	let page = getNextPage(data);
	return async (dispatch) => {
		dispatch({ ...data, type: UPDATE, loading: true })
		const res = await api.get({ endpoint: `users/${user?.username}/${user?.role === "SPECIALIST" ? "patients" : "favourites" }${ page ? "/?page="+page : "/" }` });
		const _pageData = pageParams(res);
		if(res?.results) dispatch({ ...res, ..._pageData, type: UPDATE, loading: false })
	}
};

export const updateMyPatientsFilters = (data = {}) => {
	return { ...data, type: UPDATE };
};
